import { InlineIndicatorsNodeHeadless } from "./InlineIndicatorsNodeHeadless.js";
import { InlineIndicators } from "./InlineIndicators.js";
import { jsx } from "react/jsx-runtime";

//#region src/nodes/InlineIndicatorsNode/InlineIndicatorsNode.tsx
var InlineIndicatorsNode = class extends InlineIndicatorsNodeHeadless {
	isDraggable() {
		return false;
	}
	canDropInside() {
		return false;
	}
	isDropTarget() {
		return false;
	}
	isIsolated() {
		return true;
	}
	isInline() {
		return false;
	}
	isKeyboardSelectable() {
		return false;
	}
	static getType() {
		return "inline-indicators";
	}
	static clone(node) {
		return $createInlineIndicatorsNode(node.__payload, node.__key);
	}
	static importJSON(serializedNode) {
		return $createInlineIndicatorsNode(serializedNode.payload);
	}
	exportJSON() {
		return super.exportJSON();
	}
	createDOM() {
		const dom = document.createElement("div");
		dom.classList.add("EditorTheme__inlineIndicatorsContainer");
		return dom;
	}
	updateDOM() {
		return false;
	}
	decorate() {
		const nodeKey = this.getKey();
		return /* @__PURE__ */ jsx(InlineIndicators, {
			...this.__payload,
			nodeKey
		});
	}
	cleanForPaste() {
		this.__payload = {
			...this.__payload,
			itemId: "",
			commentsCount: 0,
			linksCount: 0,
			tagsCount: 0,
			reactions: []
		};
	}
};
function $createInlineIndicatorsNode(payload, nodeKey) {
	return new InlineIndicatorsNode(payload, nodeKey);
}
function $isInlineIndicatorsNode(node) {
	return node instanceof InlineIndicatorsNode;
}

//#endregion
export { $createInlineIndicatorsNode, $isInlineIndicatorsNode, InlineIndicatorsNode };
//# sourceMappingURL=InlineIndicatorsNode.js.map